import DividerLine from "components/common/divider/line";
import SkeletonBlock from ".";

export const StrategyTempleteSkeleton = () => {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col gap-4 pb-4">
        <div className="flex flex-col px-6 pt-[30px] gap-2">
          <div className="flex items-center gap-1">
            <SkeletonBlock width={150} height={28} />
          </div>
          <div className={`flex items-center gap-1`}>
            <SkeletonBlock width={175} height={32} />
          </div>
          <SkeletonBlock width={103} height={22} />
        </div>

        <div className="flex flex-col py-2 gap-2">
          <div className="items-center flex gap-3 py-2 px-6">
            <div className="grow">
              <SkeletonBlock width={150} height={28} />
            </div>
            <SkeletonBlock width={50} height={28} />
          </div>
          <div className="items-center flex gap-3 py-2 px-6">
            <div className="grow">
              <SkeletonBlock width={150} height={28} />
            </div>
            <SkeletonBlock width={50} height={28} />
          </div>
          <div className="items-center flex gap-3 py-2 px-6">
            <div className="grow">
              <SkeletonBlock width={150} height={28} />
            </div>
            <SkeletonBlock width={50} height={28} />
          </div>
        </div>
      </div>
      <DividerLine size="xl" />
      <div className="flex flex-col">
        <div className="px-4 py-4 flex items-center">
          <div className="px-2">
            <SkeletonBlock width={50} height={28} />
          </div>
          <div className="px-2">
            <SkeletonBlock width={100} height={28} />
          </div>
        </div>
        <div className="p-6 pt-2">
          <SkeletonBlock width={"100%"} height={260} />
        </div>
      </div>
      <DividerLine size="xl" />
      <div className="flex flex-col gap-4 pb-4">
        <div className="flex flex-col px-6 pt-[30px] gap-2">
          <SkeletonBlock width={40} height={28} />
          <SkeletonBlock width={175} height={32} />
        </div>

        <div className="flex flex-col py-2 gap-2">
          <div className="items-center flex gap-3 py-2 px-6">
            <div className="grow">
              <SkeletonBlock width={150} height={28} />
            </div>
            <SkeletonBlock width={60} height={28} />
          </div>
          <div className="items-center flex gap-3 py-2 px-6">
            <div className="grow">
              <SkeletonBlock width={150} height={28} />
            </div>
            <SkeletonBlock width={60} height={28} />
          </div>
          <div className="items-center flex gap-3 py-2 px-6">
            <div className="grow">
              <SkeletonBlock width={150} height={28} />
            </div>
            <SkeletonBlock width={60} height={28} />
          </div>
        </div>
      </div>
    </div>
  );
};

export const ReturnSectionSkeleton = () => {
  return (
    <div className="flex flex-col gap-2">
      <div className="px-6 pt-[30px] flex flex-col gap-5 ">
        <SkeletonBlock width={154} height={38} />
        <SkeletonBlock width={120} height={28} />
      </div>
      <div className="px-6 py-2 justify-between items-center flex">
        <div className="flex flex-col justify-center  gap-2 py-2">
          <SkeletonBlock width={120} height={60} />
        </div>
      </div>
    </div>
  );
};
export const ReturnListSkeleton = ({ count }: { count?: any }) => {
  return (
    <div className="flex flex-col gap-2 px-6">
      {Array.from({ length: count || 5 }).map((_, index) => (
        <div className="flex items-center justify-between h-[66px]" key={index}>
          <SkeletonBlock width={180} height={40} />
          <SkeletonBlock width={80} height={30} />
        </div>
      ))}
    </div>
  );
};

export const StockListSkeleton = () => {
  return (
    <div className="w-full flex flex-col bg-white pb-4">
      <div className={`pt-[30px] pl-6`}>
        <SkeletonBlock width={70} height={30} />
      </div>
      <div className="px-6 py-4 flex items-center gap-4 ">
        <SkeletonBlock width={125} height={46} />
        <SkeletonBlock width={125} height={46} />
      </div>
      <div className="flex flex-col gap-2 py-2">
        <div className="w-full flex justify-end px-6">
          <SkeletonBlock width={80} height={16} />
        </div>
        <div className="px-6 gap-2 flex flex-col ">
          <SkeletonBlock width={"100%"} height={66} />
          <SkeletonBlock width={"100%"} height={66} />
          <SkeletonBlock width={"100%"} height={66} />
        </div>
      </div>
    </div>
  );
};
